import { useQuery } from '@tanstack/react-query';
import { axios } from '@/lib/axios/axios';
import { MESSAGING_API_BASE, messagingQueryKeys } from '../config';

export type ChannelFilesQuery = {
  channelId: number;
  limit?: number;
  offset?: number;
};

const getChannelFiles = async (params: ChannelFilesQuery) => {
  const { channelId, limit = 50, offset = 0 } = params;
  const qs = new URLSearchParams({
    limit: String(limit),
    offset: String(offset),
  });
  return axios.get(`${MESSAGING_API_BASE}/channels/${channelId}/files?${qs}`);
};

export const useFiles = ({
  channelId,
  limit = 50,
  offset = 0,
}: ChannelFilesQuery) => {
  return useQuery({
    queryKey: messagingQueryKeys.files(channelId),
    queryFn: () => getChannelFiles({ channelId, limit, offset }),
    enabled: channelId > 0,
    staleTime: 1000 * 60, // 1 minute
  });
};

export const downloadFileUrl = (channelId: number, accessKey: string) => {
  return `${MESSAGING_API_BASE}/channels/${channelId}/files/${accessKey}`;
};

export const previewFileUrl = (channelId: number, accessKey: string) => {
  return `${MESSAGING_API_BASE}/channels/${channelId}/files/${accessKey}?inline=true`;
};
